import React from 'react';
import "../../../components/calcInputs/calcInputs.css"

const CompaniesInputs = (props) => {

    return ( 
        <>
            <div className="inputsBox">
                <form id="calcForm" noValidate>
                    <div className="fullRow">
                        <div className="mainRow2">
                            <div className="row">
                                <div className="rCol1">
                                    <label htmlFor="actualCompanyName">
                                    Nazwa <span className="requiredStar">*</span>
                                    <input type="text" id="actualCompanyName" name="actualCompanyName" value={props.actualCompanyName} onChange={props.handleActualCompanyNameChange}/>
                                    </label>
                                </div>
                                <div className="rCol2">
                                    <label htmlFor="actualCompanyTemplateID">
                                    ID szablonu analizy <span className="requiredStar">*</span>
                                    <input type="text" id="actualCompanyTemplateID" name="actualCompanyTemplateID" value={props.actualCompanyTemplateID} onChange={props.handleActualCompanyTemplateIDChange}/>
                                    </label>
                                </div>
                                <div className="rCol3">
                                    <label htmlFor="actualCompanyFolderID">
                                    ID folderu <span className="requiredStar">*</span>
                                    <input type="text" id="actualCompanyFolderID" name="actualCompanyFolderID" value={props.actualCompanyFolderID} onChange={props.handleActualCompanyFolderIDChange}/>
                                    </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="rCol1_4">
                                <button className="buttonSubForm" onClick={props.handleAddCompany}>DODAJ</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
        </>
     );
}
 
export default CompaniesInputs;